import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { EventGuestModel } from '@app/events/shared/event-guest.model';

@Component({
  selector: 'app-guest-allergens-column',
  standalone: true,
  imports: [NgClass],
  templateUrl: './guest-allergens-column.component.html',
})
export class GuestAllergensColumnComponent {
  @Input('item') protected item!: EventGuestModel;

  protected chipClasses(allergen: string): string {
    switch (allergen) {
      case 'Celery':
      case 'Mustard':
        return 'bg-amber-50 text-amber-700';
      case 'Cereals containing gluten':
      case 'Sesame':
        return 'bg-orange-50 text-orange-700';
      case 'Crustaceans':
      case 'Molluscs':
        return 'bg-sky-50 text-sky-700';
      case 'Eggs':
      case 'Milk':
        return 'bg-blue-50 text-blue-700';
      case 'Fish':
      case 'Sulphur dioxide / sulphites':
        return 'bg-cyan-50 text-cyan-700';
      case 'Lupin':
      case 'Peanuts':
        return 'bg-red-50 text-red-700';
      case 'Soybeans':
      case 'Tree nuts':
        return 'bg-emerald-50 text-emerald-700';
      default:
        return 'bg-gray-100 text-gray-700';
    }
  }
}
